import api from "@/api/motivation"

export default {
  async getBalance({commit}: any) {
    const result = await api.getBalance()
    commit("setBalance", result?.balance)
    commit("setEvent", result?.event)
    commit("setEnded", result?.event?.is_active === false)
    return result
  },
  async activateCode({commit}: any, code: string) {
    const result = await api.activateCode(code)
    if (result?.balance) {
      commit("setBalance", result.balance)
    }
    return result
  },
  async getBonuses({commit}: any, params: any) {
    const result = await api.getBonuses(params)
    commit("setBonuses", {results: result?.results, count: result?.count})
    return result
  },
  async getAvailableBonuses({commit}: any) {
    const result = await api.getBonuses({status: 1, size: 100})
    commit("setAvailableBonuses", result?.results || [])
    return result
  },
  async assembleBonus(_: any, letters: string[]) {
    return api.assembleBonus(letters)
  },
}
